clients-index
  forms-clients-search(tag-scope="forms_clients_search")
  clients-table(tag-scope="clients_table")
  script(type="typescript").
    this.mixin('base');
